import { createEntitySlice } from "../firestoreModuleUtils/slice";
import { UserMediumDirectory } from "./records";

const slice = createEntitySlice<UserMediumDirectory>({
  name: "userMediumDirectories",
});

export const reducer = slice.reducer;
export const actions = slice.actions;
